import { createAction, props } from '@ngrx/store';

export const loadServices = createAction('[Services] Load Services');

export const loadServicesSuccess = createAction(
  '[Services] Load Services Success',
  props<{ services: any[] }>()
);

export const loadServicesFailure = createAction(
  '[Services] Load Services Failure',
  props<{ error: string }>()
);
